export default "__VITE_ASSET__BPDFMJgU__"